import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import EventDetail from "@/pages/EventDetail";
import LiveDetail from "@/pages/LiveDetail";
import Profile from "@/pages/Profile";
import MapView from "@/pages/MapView";
import Checkout from "@/pages/Checkout";
import MyTickets from "@/pages/MyTickets";
import ReplayHub from "@/pages/ReplayHub";
import PremiumLive from "@/pages/PremiumLive";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/event/:id" element={<EventDetail />} />
          <Route path="/checkout/:eventId" element={<Checkout />} />
          <Route path="/tickets" element={<MyTickets />} />
          <Route path="/replay" element={<ReplayHub />} />
          <Route path="/live-access/:eventId" element={<PremiumLive />} />
          <Route path="/live/:id" element={<LiveDetail />} />
          <Route path="/profile/:username" element={<Profile />} />
          <Route path="/map" element={<MapView />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors offset={80} />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
